module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-483.6085c83.woff2";